import type { RuntimePhase } from "@/runtime/types";

export function getRuntimeStatusMessage(phase: RuntimePhase): string {
  switch (phase) {
    case "checking":
      return "Checking this device";
    case "loading-engine":
      return "Loading spatial tracking";
    case "requesting-permission":
      return "Waiting for camera permission";
    case "tracking-initializing":
      return "Move slowly while tracking initializes";
    case "tracking-limited":
      return "Point toward a textured surface";
    case "searching-surface":
      return "Move slowly to find a surface";
    case "paused":
      return "Tracking paused";
    case "recovering":
      return "Preserving your experience";
    default:
      return "Preparing the scene";
  }
}
